export const DEFAULT_USERNAME = 'Unknown';
export const USERNAME_MIN_LEN = 2;
export const USERNAME_MAX_LEN = 32;
export const DEFAULT_COLOR = '#00bfff';
export const COLOR_LEN = DEFAULT_COLOR.length;
export const AVATAR_MAX_LEN = 512;
export const USERS_MAX = 64;
export const MAX_USERS_INFINITE = 0;
export const DEFAULT_USERS_MAX = MAX_USERS_INFINITE;
